import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { BatchInfoModel } from '../../Models/Domains/Orders/Batch/BatchInfoModel';

declare var IS_RUNNING_IN_APP_POOL;

export class BatchClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(model: BatchInfoModel): Promise<BatchInfoModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Orders/Batch/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model }

    return AjaxWrapper.post<BatchInfoModel, any>(url, data);
  }
}

